import sortedCountries from "../../inc/_sorted-countries";
import { extractPaymentData, formatDate, labelPatcher, strRemoveSpaces, translation as t, validateBirthday, validateFiscalNumber } from "../../inc/helpers";
import paypal from "../../inc/paypal";
import paypalSubscription from "../../inc/paypal-subscription";
import stripe from "../../inc/stripe";
import Form from "./form/Form";

const locale = TheApp.Env.LocaleShort;

export default class PanelDonate {
    constructor({
        panel,
        onOpen = null,
        onClose = null,
        setLoading = null,
        showModal = null
    }) {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;

        this._panelBody = this._panel?.querySelector(".js-dialog-donate-body");
        this._btnClose = this._panel?.querySelector(".js-btn-close");
        this._screens = this._panelBody?.querySelectorAll(".js-donate-screen");
        this._paymentMethod = this._panel?.querySelector(".js-payment-method");
        this._btnStripe = {
            btn: this._paymentMethod?.querySelector(".js-btn-stripe"),
            GWUID: "STRIPE"
        };
        this._btnPaypal = {
            btn: this._paymentMethod?.querySelector(".js-btn-paypal"),
            GWUID: "PAYPAL"
        };
        [this._btnStripe, this._btnPaypal].forEach(b => {
            b.btn?.addEventListener("click", this.onBtnPaymentClick.bind(this, b.GWUID));
            b.btn?.addEventListener("keydown", this.onBtnPaymentClick.bind(this, b.GWUID));
        });

        this._stepCurr = 0;
        this._data = {};

        this._scrolling = null;
        this._timing = 250;

        this._project = null;
        this._forms = [];
    }

    show() {
        if (!this._panel.classList.contains("is-visible"))
            this._panel.classList.add("is-visible");

        this._onOpen?.();
    }

    hide() {
        this._panel.classList.remove("is-visible");
        this._onClose?.(this._panel);
    }

    init() {
        this.onPreselectedProject();
        this.renderProjects();
        this.initSelectCountry();
        this.initForms();

        this._btnClose?.addEventListener("click", this.hide.bind(this));
    }

    onPreselectedProject() {
        const radio = this._panelBody.querySelector(".js-donation-type .input-radio[data-value='PreselectedProject']");
        const p = TheApp.Projects?.find(p => p.Uid === this._project);

        if (!(this._project?.length > 0 && p)) {
            radio?.remove();
            return;
        }

        const img = radio?.querySelector(".card-thumb img");
        const title = radio?.querySelector(".card-title");
        const desc = radio?.querySelector(".card-content");

        img.src = p.Image;
        title.innerHTML = p.Title;
        desc.innerHTML = p.Abstract;

        radio.classList.remove("is-hidden");
    }

    renderProjects() {
        const cont = this._panelBody?.querySelector(".input[data-name='Project']");
        const projectsCont = cont?.querySelector(".js-input-projects");
        const template = document.getElementById("template-input-project");
        const projects = TheApp.Projects;

        projects?.forEach((p, i) => {
            const project = template.cloneNode(true);
            project.removeAttribute("id");
            project.setAttribute("data-value", p.Uid);

            const lbl = strRemoveSpaces(`${p.Title.toLowerCase()}${i}`);
            const img = project.querySelector(".card-thumb img");
            const title = project?.querySelector(".card-title");
            const desc = project?.querySelector(".card-content");

            project.setAttribute("aria-labelledby", lbl);
            img.src = p.Image;
            title.innerHTML = p.Title;
            title.id = lbl;
            desc.innerHTML = p.Abstract;

            projectsCont?.appendChild(project);
        });
    }

    initSelectCountry() {
        const select = this._panel.querySelector(".js-select-country");
        if (!select) return;

        sortedCountries?.forEach((c, i) => {
            const opt = document.createElement("option");
            opt.value = c.alpha2;
            opt.textContent = c?.[locale];
            select.appendChild(opt);
        });

        select.value = locale;

        const baseUrl = "../../assets/world-countries/flags/flat/64x48/";
        const formatState = (state) => {
            if (!state.id) return;

            const $state = $(
                `
                <img src="${baseUrl}${state.id}.png" alt="${state.text}" draggable="false" />
                <span>${state.text}</span>
                `
            );

            return $state;
        }

        $(select).select2({
            templateResult: formatState,
            "language": {
                "noResults": () => {
                    return t("ERROR.NoResults")
                }
            }
        });
    }

    handleSelectCountryChange(form) {
        const select = this._panel.querySelector(".js-select-country");
        const input = form.inputs.find(input => input.name === "Country");
        const target = form.inputs.find(input => input.name === "FiscalNumber");
        const handleChange = (input, target) => {
            target.reset();

            if (input.value !== "it") {
                target.required = false;
                target.disabled = true;
                target.hidden = true;

                return;
            }

            target.required = true;
            target.disabled = false;
            target.hidden = false;
        }

        if (!(input && target)) return;

        if (select.value)
            input.value = select.value;

        handleChange(input, target);

        $(select).on("change", (e) => {
            const id = e.target.value;
            input.value = id;
            this._data[input.name] = input.value;
            handleChange(input, target);
        });
    }

    initForms() {
        this._screens?.forEach((s, i) => {
            const _dispatcher = (form) => {
                this.extractFormData(form);
                this[`watchScreen${i}`](form);
            }
            const f = s.querySelector(".js-form-donate");
            const form = new Form({
                form: f,
                onSubmit: this.handleFormSubmit.bind(this, parseInt(s.dataset.step)),
                onFormReady: (form) => {
                    this[`onFormReady${i}`](form);

                    form.init();
                    form.dispatcher = _dispatcher;

                    _dispatcher(form);
                    this._forms.push(form);
                }
            });

            const btnEditForm = s.querySelector(".js-edit-form");
            const summary = s.querySelector(".js-section-summary");

            btnEditForm?.addEventListener("click", this.onBtnEditFormClick.bind(this, { i, f, form, s, summary }));
        });
    }

    extractFormData(form) {
        for (const [key, value] of Object.entries(form.data))
            this._data[key] = value;
    }

    onFormReady0(form) {
        const amountFree = form.inputs.find(input => input.name === "AmountFree");
        const error = form.el.querySelector(".js-input-error-amount-free");
        amountFree.error = error;
    }

    onFormReady1(form) {
        const inputDate = form.inputs.find(input => input.name === "Birthday");
        const now = new Date();
        const min = new Date().setFullYear(parseInt(now.getFullYear()) - 18);
        const max = new Date("01/01/1900");
        inputDate.min = min;
        inputDate.max = max;
        inputDate.validate = () => validateBirthday(inputDate);

        const inputFiscalNumber = form.inputs.find(input => input.name === "FiscalNumber");
        inputFiscalNumber.validate = () => validateFiscalNumber(inputFiscalNumber);

        this.handleSelectCountryChange(form);
    }

    onFormReady2(form) { }

    watchScreen0(form) {
        const DonationType = form.inputs.find(input => input.name === "DonationType");
        const Project = form.inputs.find(input => input.name === "Project");
        const inputs =
            form.inputs
                .filter(input => input.name !== "DonationType" && input.name !== "Project" && input.name !== "PreselectedProject");

        this.handleInputDonationType(DonationType, inputs);

        if (DonationType.value === "FreeContribution") {
            this.handleFormSubmit(0, form);

        } else if (DonationType.value === "Project") {
            if (!Project.valid.flag) {
                this.scrollBody(Project.container);
                return;
            }

            this.handleFormSubmit(0, form);

        } else if (DonationType.value === "PreselectedProject") {
            Project.value = this._project;
            Project.valid = { flag: true, msg: "" };
            this._data.Project = Project.value;

            this.handleFormSubmit(0, form);
        }
    }    

    watchScreen1(form) {
        // console.log(form, 1);
    }

    watchScreen2(form) {
        // console.log(form, 2);
    }

    handleInputDonationType(input, siblings) {
        if (siblings.some(input => input.valid.flag === false)) {
            input.disabled = true;

            return;
        }

        input.disabled = false;
    }

    handleFormSubmit(i, form, e) {
        // console.log(form.data);
        if (form.errors?.length > 0) {
            console.log(form.errors);
            return;
        }

        this._stepCurr = parseInt(i);

        if (!form.el.classList.contains("is-hidden"))
            form.el.classList.add("is-hidden");

        this.renderSummary(this._stepCurr, form.data);

        const sectionNext = this._panelBody?.querySelector(`.js-donate-screen[data-step="${this._stepCurr + 1}"]`);
        sectionNext?.classList.remove("is-hidden");

        //const formNext = this._forms[i + 1];
        //formNext?.inputs?.forEach(input => {
        //    const hasValue =
        //        Array.isArray(input.value)
        //            ? input.value.length > 0
        //            : input.value;

        //    if (!hasValue && input.valid.flag === false) {
        //        input.reset();
        //    }
        //});

        if (i === 1) {
            this._forms[i + 1]?.reset();
            this._panel.querySelector(".payment-widget")?.remove();
        }

        this.scrollBody(sectionNext);
    }

    scrollBody(section) {
        const fontSize = window.getComputedStyle(document.body).getPropertyValue("font-size");
        const gap = window.getComputedStyle(document.body).getPropertyValue("--gap-400");
        const offset = parseFloat(gap) * parseFloat(fontSize);

        clearTimeout(this._scrolling);
        this._scrolling = setTimeout(() => {
            this._panelBody.scrollBy({
                top: section.offsetTop - this._panelBody.scrollTop - offset / 2,
                left: 0,
                behaviour: "smooth"
            });
        }, this._timing);
    }

    onBtnEditFormClick(payload) {
        const { i, f, form, s, summary } = payload;

        Array.from(this._screens).slice(i + 1, this._screens.length).forEach((screen) => {
            const f = screen.querySelector(".js-form-donate");
            const summary = screen.querySelector(".js-section-summary");

            if (!screen.classList.contains("is-hidden"))
                screen.classList.add("is-hidden");

            f.classList.remove("is-hidden");

            if (!summary?.classList.contains("is-hidden"))
                summary?.classList.add("is-hidden");
        });

        f.classList.remove("is-hidden");

        if (!summary?.classList.contains("is-hidden"))
            summary?.classList.add("is-hidden");

        if (i === 0) {
            const DonationType = form.inputs.find(input => input.name === "DonationType");
            const Project = form.inputs.find(input => input.name === "Project");
            const inputs =
                form.inputs.filter(input => input.name !== "DonationType" && input.name !== "Project");

            DonationType?.reset();
            Project?.reset();

            this.handleInputDonationType(DonationType, inputs);
        }

        this.scrollBody(s);
    }

    renderSummary(i, data) {
        const summary = this._panelBody.querySelector(`.js-donate-screen[data-step="${i}"] .js-section-summary`);
        const labels = [];

        for (const [key, value] of Object.entries(data)) {
            const _label = this._panelBody?.querySelector(`.js-${key}`);
            const _value = labelPatcher(this._panelBody, this._data, key, value);

            if (!_value) {
                _label?.style.setProperty("display", "none");
                continue;
            }

            if (_label) {
                _label.style.removeProperty("display");
                labels.push({ label: _label, value: _value });
            }
        }

        labels.forEach(l => l.label.innerHTML = l.value);
        summary?.classList.remove("is-hidden");
    }

    onBtnPaymentClick(GWUID, e) {
        if (e.type === "keydown") {
            if (e.key === " ") e.preventDefault();
            else return;
        }

        const data = extractPaymentData(this._data, GWUID);
        const widget = document.getElementById("template-payment-widget").cloneNode(true);
        let callback;

        console.log(data);

        widget.removeAttribute("id");
        if (GWUID === "PAYPAL") {
            widget.innerHTML = "";

            if (data.Recurrence === "monthly") {
                callback = paypalSubscription;

            } else {
                callback = paypal;
            }

        } else
            callback = stripe;

        this._panel.querySelector(".payment-widget")?.remove();
        this._paymentMethod?.after(widget);
       
        callback({
            elem: widget,
            data,
            onSuccess: (args) => {
                // console.log('SUCCESS', args);
                window.location.href = `${TheApp.Env.BaseUrlNls}?transaction=success`;
            },
            onCancel: (args) => {
                // console.log('CANCEL', args);
                this._showModal(t("lblDonationCancelTitle"), t("lblDonationCancelMessage"));
            },
            onError: (...args) => {
                // console.log('------->ERROR', args);                                   
                this._showModal(t("lblDonationErrorTitle"), t("lblDonationErrorMessage"));
            },
            onCreateError: (...args) => {
                const errs = args?.find(a => a?.Errors?.length > 0);
                if (errs) this.onCreateDonationError(errs);
            },
            setLoading: this._setLoading?.bind(this)
        });
    }

    onCreateDonationError(errs) {
        const { Errors } = errs;
        console.log(Errors);
        const fields = Errors.map(err => ({ Field: err.Field, Message: err.Message }));
        const inputs =
            this._forms?.map(form => form.inputs)?.flat()?.filter(input => fields.find(field => field.Field === input.name));

        // console.log(fields, inputs);
        inputs?.forEach((input) => {
            const msg = fields?.find(field => field.Field === input.name)?.Message;
            const valid = { flag: false, msg };
            input.valid = valid;
            input.toggleValidation();

            this._panel.querySelector(".js-edit-form")?.click();
        });

        this._showModal(t("lblInputsErrorTitle"), t("lblInputsErrorMessage"));
    }

    get data() {
        return this._data;
    }

    set project(uid) {
        this._project = uid;
    }

    get forms() {
        return this._forms;
    }
}